import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import TaskList from './tasks'
import PurchaseOrderList from './purchaseOrders'

import { LAYOUT_VENDOR_JOB_SHOW } from '../../navigation'
import { LAYOUT_VENDOR_FINANCE_PO_SHOW } from '../../finance/navigation'
import Modal from '../../../../components/job/modal/vendor'

import CustomPanel from './collapse'

const OfferedIcon = require('../../../../assets/icons/confirmation.png')
const InProgressIcon = require('../../../../assets/icons/in-progress.png')
const DeadlineIcon = require('../../../../assets/icons/deadline.png')
const PurchaseOrderIcon = require('../../../../assets/icons/invoice.png')

const Dashboard = (props) => {
  const history = useHistory()
  const [modalVisible, setModalVisible] = useState(false)
  const [modalId, setModalId] = useState(null)

  const viewJob = (id) => {
    setModalId(id)
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
    setModalId(null)
  }

  const { inProgress, offered, upcoming, loading, error, purchaseOrdersInReview } = props

  /**
   * Tasks variables
   */
  const countInProgress = (inProgress || []).length
  const countOffered = (offered || []).length
  const countUpcomingVendorDDL = (upcoming || []).length
  const countPOsInReview = (purchaseOrdersInReview || []).length

  const viewMore = (id) => history.push(LAYOUT_VENDOR_JOB_SHOW(id))
  const viewMorePO = (id) => history.push(LAYOUT_VENDOR_FINANCE_PO_SHOW(id))
  const quickView = (id) => viewJob(id)

  return (
    <>
      <CustomPanel
        count={countPOsInReview}
        type='info'
        icon={PurchaseOrderIcon}
        title='Purchase Orders in Review'
        error={error}
        loading={loading}
      >
        <PurchaseOrderList
          list={purchaseOrdersInReview}
          error={error}
          loading={loading}
          viewMore={viewMorePO}
        />
      </CustomPanel>

      <br />
      <CustomPanel
        count={countOffered}
        type='info'
        icon={OfferedIcon}
        title='Offered to Vendors'
        error={error}
        loading={loading}
      >
        <TaskList list={offered} error={error} loading={loading} quickView={quickView} viewMore={viewMore} />
      </CustomPanel>

      <CustomPanel
        count={countInProgress}
        type='info'
        icon={InProgressIcon}
        title='Task in Progress.'
        error={error}
        loading={loading}
      >
        <TaskList list={inProgress} error={error} loading={loading} quickView={quickView} viewMore={viewMore} />
      </CustomPanel>

      <CustomPanel
        count={countUpcomingVendorDDL}
        type='info'
        icon={DeadlineIcon}
        title='Upcoming Vendor DDL.'
        error={error}
        loading={loading}
      >
        <TaskList list={upcoming} error={error} loading={loading} quickView={quickView} viewMore={viewMore} />
      </CustomPanel>

      <br />

      <Modal forVendor visible={modalVisible} id={modalId} onCancel={hideModal} />
    </>
  )
}

export default Dashboard
